import PageConfigs from "#routers/PageConfigs";
import history from "#routers/history";
import {
  SideNavigation,
  type SideNavigationProps,
} from "@validereinc/common-components";
import { find } from "es-toolkit/compat";
import React, { useState } from "react";
import { linkToUserSetting } from "../../../Routers/links";
import { isLinkIncludeInPath } from "./SideNavigation.helpers";

// IMPROVE: this function and related code is smelly
function getActiveTabKey() {
  return find(Object.keys(PageConfigs), (key) => {
    return isLinkIncludeInPath(PageConfigs[key].link);
  });
}

// IMPROVE: this needs a holistic refactor
export const SideNavigationWired = ({
  tabs,
  name,
  version,
  onSignOutClick,
  hideFooter,
  ...restProps
}: Omit<SideNavigationProps, "onProfileClick">) => {
  const [activeTabKey] = useState<string>(getActiveTabKey() as string);

  return (
    <SideNavigation
      activeTab={activeTabKey}
      tabs={tabs}
      name={name}
      onProfileClick={() => history.push(linkToUserSetting())}
      onSignOutClick={onSignOutClick}
      version={version}
      hideFooter={hideFooter}
      shouldExpandWhenHoveredOrFocused={false}
      {...restProps}
    />
  );
};
